import { z } from 'zod';
/**
 * Phone number in E.164 format.
 *
 * E.164: leading '+', country code (1-3 digits), then up to 12 digits.
 * Total length: between 8 and 15 digits including country code.
 *
 *   Valid:   +33612345678, +14155552671, +447700900123
 *   Invalid: 0612345678 (no country code), +33 6 12 34 56 78 (spaces),
 *            123 (too short)
 *
 * Why strict E.164:
 *   - Twilio requires E.164 for outbound calls and SMS
 *   - Avoids ambiguous local formats across multi-tenant agencies
 *   - Enforces a single canonical form in the database
 *
 * The frontend should format user-entered numbers to E.164 before submit
 * (libphonenumber-js or equivalent). The backend rejects non-E.164 with
 * a 400 VALIDATION_ERROR.
 */
export const PhoneNumberSchema = z
    .string()
    .trim()
    .regex(/^\+[1-9]\d{7,14}$/, 'Phone number must be in E.164 format (e.g. +33612345678)');
//# sourceMappingURL=phone-number.schema.js.map